import axios from "axios";

const base = `${process.env.REACT_APP_BACKEND_URL}/agent`;
const headers = () => ({ headers: { Authorization: "Bearer " + localStorage.getItem("token") } });

export const getStatus = () => axios.get(`${base}/status`, headers()).then(r => r.data);

export const sendCommand = ({ text, history, language, source, page }) =>
  axios
    .post(`${base}/command`, { text, history, language, source, page }, headers())
    .then(r => r.data);

export const confirmAction = (id, force = false) =>
  axios.post(`${base}/actions/${id}/confirm`, { force }, headers()).then(r => r.data.action);

export const dismissAction = id =>
  axios.post(`${base}/actions/${id}/dismiss`, {}, headers()).then(r => r.data.action);

export const transcribeAudio = (blob, language) => {
  const body = new FormData();
  body.append("audio", blob, "command.wav");
  body.append("language", language);
  return axios.post(`${base}/transcribe`, body, headers());
};

export const errorText = (error, fallback) =>
  error?.response?.data?.errorMessage || error?.message || fallback;

export const getUsage = month =>
  axios.get(`${base}/usage`, { ...headers(), params: { month } }).then(r => r.data);
